import ProtectedRoute from "@/components/layout/ProtectedRoute";
import Screen from "@/components/layout/Screen";
import PageTitle from "@/components/shared/PageTitle/PageTitle";
import PlateForm from "@/components/shared/PlateForm";
import { Box } from "@/components/ui/box";
import { HStack } from "@/components/ui/hstack";
import { Skeleton, SkeletonText } from "@/components/ui/skeleton";
import { VStack } from "@/components/ui/vstack";
import { useVehicle } from "@/hooks/useVehicle";
import { useT } from "@transifex/react";

const NewPlate = () => {
  const { addPlate, isPending, accountIsFetching } = useVehicle();
  const t = useT();

  if (accountIsFetching) {
    return <NewPlateScreenSkeleton />;
  }

  return (
    <ProtectedRoute>
      <Screen>
        <PageTitle title={t("Add New Plate")} />
        <PlateForm
          defaultValues={{
            plate: "",
            nickname: "",
          }}
          onSubmit={addPlate}
          loading={isPending}
        />
      </Screen>
    </ProtectedRoute>
  );
};

export default NewPlate;

function NewPlateScreenSkeleton() {
  return (
    <Screen>
      <Box className="items-center">
        <SkeletonText className="h-[20px] w-[143px] rounded-md" />
      </Box>

      <VStack className="gap-[10px] mb-6">
        <SkeletonText className="h-[14px] w-[100px] rounded-md my-4" />
        <Skeleton className="h-[52px] w-full mb-2" />
        <SkeletonText className="h-[14px] w-[100px] rounded-md my-4" />
        <Skeleton className="h-[52px] w-full mb-2" />
      </VStack>

      <HStack className="gap-[12px]">
        <Skeleton variant="rounded" className="h-[52px] flex-1" />
        <Skeleton variant="rounded" className="h-[52px] flex-1" />
      </HStack>
    </Screen>
  );
}
